unit unit_Inventur;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Connection, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Vcl.Grids, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTableView, WEBLib.Buttons, WEBLib.Grids,
  WEBLib.FlexControls, WEBLib.WebCtrls, DB;

type
  TfrmInventur = class(TForm)
    xdsInventurERF: TXDataWebDataSet;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    xdsInventuren: TXDataWebDataSet;
    xdsInventurenInventurDatum: TDateTimeField;
    xdsInventurenBearbeitung: TStringField;
    labelinventuren: TLabel;
    btnzurueck: TButton;
    xdsInventurERFArtikelnummer: TXDataWebEntityField;
    xdsInventurERFLager: TXDataWebEntityField;
    xdsInventurERFInventurdatum: TDateTimeField;
    xdsInventurERFArtikelueberschrift: TStringField;
    xdsInventurERFArtikelbeschreibung: TStringField;
    xdsInventurERFBestand: TFloatField;
    xdsInventurERFBemerkung: TStringField;
    xdsInventurERFLetzterEK: TFloatField;
    xdsInventurERFDurchschnittEK: TFloatField;
    xdsInventurERFBenutzergeaendert: TStringField;
    xdsInventurERFDatumgeaendert: TDateTimeField;
    xdsInventurERFArtikelEK: TFloatField;
    xdsInventurERFBuchbestand: TFloatField;
    xdsInventurERFBuchbestandswert: TFloatField;
    xdsInventurERFDifferenzBestand: TFloatField;
    xdsInventurERFNeuerBestandswert: TFloatField;
    xdsInventurERFKorrekturDatum: TDateTimeField;
    xdsInventurERFDifferenzBestandswert: TFloatField;
    xdsLager: TXDataWebDataSet;
    xdsLagerLager: TStringField;
    ComboLager: TComboBox;
    Container4: THTMLContainer;
    btnScan: TButton;
    edtSuchbegriff: TEdit;
    DataSet: TXDataWebDataSet;
    DataSetArtikelnummer: TStringField;
    DataSetArtikelueberschrift: TStringField;
    DataSetArtikelbeschreibung: TStringField;
    DataSetVerkaufspreis: TFloatField;
    DataSetBestand: TFloatField;
    DataSetArtikelmatchcode: TStringField;
    DataSetEAN: TStringField;
    edtMenge: TEdit;
    btnSpeichern: TButton;
    TCErfassung: TTableControl;
    TCLetzte10: TTableControl;
    LabelLetzteErfassungen: TLabel;
    xdsInventurERFArtikelnummerArtikelnummer: TStringField;
    xdsInventurERFLagerLager: TStringField;
    labelsuchergebnis: TLabel;
    DataSetEinkaufspreis: TFloatField;
    XDSNEU: TXDataWebDataSet;
    XDSNEUArtikelnummer: TXDataWebEntityField;
    XDSNEULager: TXDataWebEntityField;
    XDSNEUInventurdatum: TDateTimeField;
    XDSNEUArtikelueberschrift: TStringField;
    XDSNEUArtikelbeschreibung: TStringField;
    XDSNEUBestand: TFloatField;
    XDSNEUBemerkung: TStringField;
    XDSNEULetzterEK: TFloatField;
    XDSNEUDurchschnittEK: TFloatField;
    XDSNEUBenutzergeaendert: TStringField;
    XDSNEUDatumgeaendert: TDateTimeField;
    XDSNEUArtikelEK: TFloatField;
    XDSNEUBuchbestand: TFloatField;
    XDSNEUBuchbestandswert: TFloatField;
    XDSNEUDifferenzBestand: TFloatField;
    XDSNEUNeuerBestandswert: TFloatField;
    XDSNEUKorrekturDatum: TDateTimeField;
    XDSNEUDifferenzBestandswert: TFloatField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsInventurERFAfterOpen(DataSet: TDataSet);
    procedure xdsInventurenAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure xdsLagerAfterOpen(DataSet: TDataSet);
    procedure edtSuchbegriffChange(Sender: TObject);
    procedure btnScanClick(Sender: TObject);
    procedure DataSetAfterOpen(DataSet: TDataSet);
    procedure btnSpeichernClick(Sender: TObject);
    procedure XDSNEUAfterPost(DataSet: TDataSet);
    procedure XDSNEUAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure XDSNEUAfterOpen(DataSet: TDataSet);

    public
    myInventurDatum:TDateTime;
  protected procedure LoadDFMValues; override; end;

var
  frmInventur: TfrmInventur;

implementation
  uses unit1, unit2, unit_BarcodeScan;
{$R *.dfm}


procedure TfrmInventur.btnScanClick(Sender: TObject);
var
  LFrm:TBarcodeScan;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TBarcodeScan;
    begin
      LForm:=(AForm as TBarcodeScan);
      //lform.mykundehint:=xdsEinzelkontaktKundennummer.AsString+' '+xdsEinzelkontaktNachname.AsString+', '+xdsEinzelkontaktVorname.asstring;
      //lForm.edttoaddress.Text:= xdsEinzelkontaktPostleitzahl.AsString+' '+xdsEinzelkontaktort.AsString+', '+xdsEinzelkontaktStrasse.AsString;

    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      edtsuchbegriff.text:=trim(lfrm.ScanErgebnis);
      edtsuchbegriffChange(self);
    end;
  begin
    if LizenzOK then
    begin
      LFrm:=TBarcodeScan.CreateNew(@AfterCreate);
      LFrm.ShowModal(@AfterShowmodal);
    end
    else
    begin
      showmessage('Für diese Funktion sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
    end;

end;

procedure TfrmInventur.btnSpeichernClick(Sender: TObject);
var
  mymenge:double;
begin
  if edtMenge.Text='' then
  begin
    showmessage('Menge muß angegeben werden');
    exit;
  end;
  if TryStrToFloat(edtMenge.Text,mymenge)=false then
  begin
    showmessage('Keine korrekte Mengenangabe');
    exit;
  end;
  if edtSuchbegriff.Text='' then
  begin
    showmessage('Kein Artikel angegeben');
    exit;
  end;
  if ComboLager.Text='' then
  begin
    showmessage('Kein Lager angegeben');
    exit;
  end;
  if xdsLager.Locate('Lager', combolager.Text,[])=false then
  begin
    showmessage('Ungültiges Lager ausgewählt');
    exit;
  end;
  if DataSetArtikelnummer.AsString<>edtSuchbegriff.text then
  begin
    showmessage('Der Artikel ist nicht angegeben');
    exit;
  end;
  xdsNEU.Append;
  xdsNEUArtikelnummer.Value:=DataSet.CurrentData;
  xdsNEULager.Value:=xdsLager.CurrentData;
  //xdsInventurERFArtikelnummerArtikelnummer.AsString:=DataSetArtikelnummer.AsString;
  xdsNEUInventurdatum.AsDateTime:=myInventurDatum;
  xdsNEUArtikelueberschrift.AsString:=DataSetArtikelueberschrift.AsString;
  xdsNEUArtikelbeschreibung.AsString:=DataSetArtikelbeschreibung.AsString;
  xdsNEUBestand.AsFloat:=mymenge;
  xdsNEULetzterEK.AsFloat:=DataSetEinkaufspreis.AsFloat;
  xdsNEUDurchschnittEK.AsFloat:=0;
  xdsNEUBuchbestand.AsFloat:=0;
  xdsNEUBuchbestandswert.AsFloat:=0;
  xdsNEUDatumgeaendert.AsDateTime:=date+time;
  xdsNEUBenutzergeaendert.AsString:=BenutzerLoginName;
  xdsNEU.Post;

end;

procedure TfrmInventur.btnzurueckClick(Sender: TObject);
begin
  xdsInventuren.Close;
  self.close;
end;

procedure TfrmInventur.DataSetAfterOpen(DataSet: TDataSet);
begin
  btnspeichern.Enabled:=false;
  if DataSet.RecordCount<1 then
  begin
    labelsuchergebnis.Caption:='Artikel nicht gefunden';
  end;
  if DataSet.RecordCount=1 then
  begin
    labelsuchergebnis.Caption:='Artikel gefunden: '+DataSetArtikelueberschrift.asstring;
    btnspeichern.Enabled:=true;
    edtMenge.SetFocus;
  end;
  if DataSet.RecordCount>1 then
  begin
    labelsuchergebnis.Caption:='mehrere Übereinstimmungen';
  end;
end;

procedure TfrmInventur.edtSuchbegriffChange(Sender: TObject);
var
  suchtext:string;
begin
  suchtext:=trim(edtsuchbegriff.Text);
  if length(suchtext)>0 then
  begin
    dataset.Close;
    dataset.QueryTop:=21;
    dataset.QueryString:='$filter=(Artikelnummer eq '+quotedstr(suchtext)+') OR (EAN eq '+quotedstr(suchtext)+')';
    dataset.Load;
  end;
end;

procedure TfrmInventur.WebFormShow(Sender: TObject);
begin
  myInventurDatum:=encodedate(2000,1,1);
  xdsLager.Load;

end;

procedure TfrmInventur.xdsInventurERFAfterOpen(DataSet: TDataSet);
var
  i:integer;
begin
  i:=0;
  TCLetzte10.RowCount:=xdsInventurERF.RecordCount+2;
  TCLetzte10.ColCount:=4;
  TCLetzte10.Cells[0,i]:='Lager';
  TCLetzte10.Cells[1,i]:='Artikelnummer';
  TCLetzte10.Cells[2,i]:='Artikelbezeichnung';
  TCLetzte10.Cells[3,i]:='Menge';

  xdsInventurERF.First;
  while not xdsinventurerf.eof do
  begin
    inc(i);
    TCLetzte10.Cells[0,i]:=xdsInventurERFLagerLager.AsString;
    TCLetzte10.Cells[1,i]:=xdsInventurERFArtikelnummerArtikelnummer.AsString;
    TCLetzte10.Cells[2,i]:=xdsInventurERFArtikelueberschrift.AsString;
    TCLetzte10.Cells[3,i]:=xdsInventurERFBestand.AsString;
    xdsinventurerf.Next;
  end;
end;

procedure TfrmInventur.xdsLagerAfterOpen(DataSet: TDataSet);
begin
  comboLager.Items.Clear;
  xdslager.First;
  while not xdslager.eof do
  begin
    combolager.Items.add(xdsLagerLager.asstring);
    xdslager.Next;
  end;
  comboLager.Visible:=false;
  comboLager.Text:='[-]';
  xdsNeu.Load;

end;

procedure TfrmInventur.XDSNEUAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    xdsInventurERF.Close;
    edtMenge.Text:='';
    edtSuchbegriff.Text:='';
    edtsuchbegriff.SetFocus;
    xdsinventurerf.Load;
  end;
end;

procedure TfrmInventur.XDSNEUAfterOpen(DataSet: TDataSet);
begin
  xdsInventuren.Load;
end;

procedure TfrmInventur.XDSNEUAfterPost(DataSet: TDataSet);
begin
  xdsNEU.ApplyUpdates;
end;

procedure TfrmInventur.xdsInventurenAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
begin

  if xdsInventuren.RecordCount>0 then
  begin
    if xdsInventurenBearbeitung.AsString='aktiv' then
    begin
      myInventurDatum:=xdsInventurenInventurDatum.AsDateTime;
      labelinventuren.Caption:='Inventurdatum: '+formatdatetime('DD.MM.YYYY',myInventurdatum);
      combolager.Visible:=true;
    end
    else
    begin
      labelinventuren.Caption:='Es gibt keine Inventur, die zur Bearbeitung freigegeben ist';
    end;
  end
  else
  begin
    labelinventuren.Caption:='Es gibt keine Inventur, die zur Bearbeitung freigegeben ist';
  end;
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Inventur</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  Container4.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  labelinventuren.ParentElement:=myelement;
  myelement:=container3.ElementHandle;
  TCErfassung.ParentElement:=myelement;
  tcerfassung.RowCount:=4;
  tcerfassung.Cells[0,1]:='Für welches Lager?';
  tcerfassung.Cells[0,2]:='Artikelnr.';
  tcerfassung.Cells[0,3]:='Menge';
  myelement:=TCErfassung.CellElements[1,1];
  ComboLager.ParentElement:=myelement;
  myelement:=TCErfassung.CellElements[1,2];
  edtsuchbegriff.ParentElement:=myelement;
  labelsuchergebnis.ParentElement:=myelement;
  myelement:=TCErfassung.CellElements[2,2];
  btnscan.ParentElement:=myelement;
  myelement:=TCErfassung.CellElements[1,3];
  edtMenge.ParentElement:=myelement;
  myelement:=TCErfassung.CellElements[2,3];
  btnSpeichern.ParentElement:=myelement;
  myelement:=container4.ElementHandle;
  LabelLetzteErfassungen.ParentElement:=myelement;
  TCLetzte10.ParentElement:=myelement;
  if myInventurDatum<>encodedate(2000,1,1) then
  begin
    xdsInventurERF.QueryString:='$filter=Inventurdatum eq '+formatdatetime('yyyy-mm-dd',myinventurdatum)+'&$expand=Artikelnummer,Lager&$orderby=Datumgeaendert DESC';
    xdsInventurERF.Load;
  end;

end;

procedure TfrmInventur.LoadDFMValues;
begin
  inherited LoadDFMValues;

  labelinventuren := TLabel.Create(Self);
  LabelLetzteErfassungen := TLabel.Create(Self);
  labelsuchergebnis := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  ComboLager := TComboBox.Create(Self);
  Container4 := THTMLContainer.Create(Self);
  btnScan := TButton.Create(Self);
  edtSuchbegriff := TEdit.Create(Self);
  edtMenge := TEdit.Create(Self);
  btnSpeichern := TButton.Create(Self);
  TCErfassung := TTableControl.Create(Self);
  TCLetzte10 := TTableControl.Create(Self);
  xdsInventurERF := TXDataWebDataSet.Create(Self);
  xdsInventurERFArtikelnummer := TXDataWebEntityField.Create(Self);
  xdsInventurERFLager := TXDataWebEntityField.Create(Self);
  xdsInventurERFInventurdatum := TDateTimeField.Create(Self);
  xdsInventurERFArtikelueberschrift := TStringField.Create(Self);
  xdsInventurERFArtikelbeschreibung := TStringField.Create(Self);
  xdsInventurERFBestand := TFloatField.Create(Self);
  xdsInventurERFBemerkung := TStringField.Create(Self);
  xdsInventurERFLetzterEK := TFloatField.Create(Self);
  xdsInventurERFDurchschnittEK := TFloatField.Create(Self);
  xdsInventurERFBenutzergeaendert := TStringField.Create(Self);
  xdsInventurERFDatumgeaendert := TDateTimeField.Create(Self);
  xdsInventurERFArtikelEK := TFloatField.Create(Self);
  xdsInventurERFBuchbestand := TFloatField.Create(Self);
  xdsInventurERFBuchbestandswert := TFloatField.Create(Self);
  xdsInventurERFDifferenzBestand := TFloatField.Create(Self);
  xdsInventurERFNeuerBestandswert := TFloatField.Create(Self);
  xdsInventurERFKorrekturDatum := TDateTimeField.Create(Self);
  xdsInventurERFDifferenzBestandswert := TFloatField.Create(Self);
  xdsInventurERFArtikelnummerArtikelnummer := TStringField.Create(Self);
  xdsInventurERFLagerLager := TStringField.Create(Self);
  xdsInventuren := TXDataWebDataSet.Create(Self);
  xdsInventurenInventurDatum := TDateTimeField.Create(Self);
  xdsInventurenBearbeitung := TStringField.Create(Self);
  xdsLager := TXDataWebDataSet.Create(Self);
  xdsLagerLager := TStringField.Create(Self);
  DataSet := TXDataWebDataSet.Create(Self);
  DataSetArtikelnummer := TStringField.Create(Self);
  DataSetArtikelueberschrift := TStringField.Create(Self);
  DataSetArtikelbeschreibung := TStringField.Create(Self);
  DataSetVerkaufspreis := TFloatField.Create(Self);
  DataSetBestand := TFloatField.Create(Self);
  DataSetArtikelmatchcode := TStringField.Create(Self);
  DataSetEAN := TStringField.Create(Self);
  DataSetEinkaufspreis := TFloatField.Create(Self);
  XDSNEU := TXDataWebDataSet.Create(Self);
  XDSNEUArtikelnummer := TXDataWebEntityField.Create(Self);
  XDSNEULager := TXDataWebEntityField.Create(Self);
  XDSNEUInventurdatum := TDateTimeField.Create(Self);
  XDSNEUArtikelueberschrift := TStringField.Create(Self);
  XDSNEUArtikelbeschreibung := TStringField.Create(Self);
  XDSNEUBestand := TFloatField.Create(Self);
  XDSNEUBemerkung := TStringField.Create(Self);
  XDSNEULetzterEK := TFloatField.Create(Self);
  XDSNEUDurchschnittEK := TFloatField.Create(Self);
  XDSNEUBenutzergeaendert := TStringField.Create(Self);
  XDSNEUDatumgeaendert := TDateTimeField.Create(Self);
  XDSNEUArtikelEK := TFloatField.Create(Self);
  XDSNEUBuchbestand := TFloatField.Create(Self);
  XDSNEUBuchbestandswert := TFloatField.Create(Self);
  XDSNEUDifferenzBestand := TFloatField.Create(Self);
  XDSNEUNeuerBestandswert := TFloatField.Create(Self);
  XDSNEUKorrekturDatum := TDateTimeField.Create(Self);
  XDSNEUDifferenzBestandswert := TFloatField.Create(Self);

  labelinventuren.BeforeLoadDFMValues;
  LabelLetzteErfassungen.BeforeLoadDFMValues;
  labelsuchergebnis.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  ComboLager.BeforeLoadDFMValues;
  Container4.BeforeLoadDFMValues;
  btnScan.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  edtMenge.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  TCErfassung.BeforeLoadDFMValues;
  TCLetzte10.BeforeLoadDFMValues;
  xdsInventurERF.BeforeLoadDFMValues;
  xdsInventurERFArtikelnummer.BeforeLoadDFMValues;
  xdsInventurERFLager.BeforeLoadDFMValues;
  xdsInventurERFInventurdatum.BeforeLoadDFMValues;
  xdsInventurERFArtikelueberschrift.BeforeLoadDFMValues;
  xdsInventurERFArtikelbeschreibung.BeforeLoadDFMValues;
  xdsInventurERFBestand.BeforeLoadDFMValues;
  xdsInventurERFBemerkung.BeforeLoadDFMValues;
  xdsInventurERFLetzterEK.BeforeLoadDFMValues;
  xdsInventurERFDurchschnittEK.BeforeLoadDFMValues;
  xdsInventurERFBenutzergeaendert.BeforeLoadDFMValues;
  xdsInventurERFDatumgeaendert.BeforeLoadDFMValues;
  xdsInventurERFArtikelEK.BeforeLoadDFMValues;
  xdsInventurERFBuchbestand.BeforeLoadDFMValues;
  xdsInventurERFBuchbestandswert.BeforeLoadDFMValues;
  xdsInventurERFDifferenzBestand.BeforeLoadDFMValues;
  xdsInventurERFNeuerBestandswert.BeforeLoadDFMValues;
  xdsInventurERFKorrekturDatum.BeforeLoadDFMValues;
  xdsInventurERFDifferenzBestandswert.BeforeLoadDFMValues;
  xdsInventurERFArtikelnummerArtikelnummer.BeforeLoadDFMValues;
  xdsInventurERFLagerLager.BeforeLoadDFMValues;
  xdsInventuren.BeforeLoadDFMValues;
  xdsInventurenInventurDatum.BeforeLoadDFMValues;
  xdsInventurenBearbeitung.BeforeLoadDFMValues;
  xdsLager.BeforeLoadDFMValues;
  xdsLagerLager.BeforeLoadDFMValues;
  DataSet.BeforeLoadDFMValues;
  DataSetArtikelnummer.BeforeLoadDFMValues;
  DataSetArtikelueberschrift.BeforeLoadDFMValues;
  DataSetArtikelbeschreibung.BeforeLoadDFMValues;
  DataSetVerkaufspreis.BeforeLoadDFMValues;
  DataSetBestand.BeforeLoadDFMValues;
  DataSetArtikelmatchcode.BeforeLoadDFMValues;
  DataSetEAN.BeforeLoadDFMValues;
  DataSetEinkaufspreis.BeforeLoadDFMValues;
  XDSNEU.BeforeLoadDFMValues;
  XDSNEUArtikelnummer.BeforeLoadDFMValues;
  XDSNEULager.BeforeLoadDFMValues;
  XDSNEUInventurdatum.BeforeLoadDFMValues;
  XDSNEUArtikelueberschrift.BeforeLoadDFMValues;
  XDSNEUArtikelbeschreibung.BeforeLoadDFMValues;
  XDSNEUBestand.BeforeLoadDFMValues;
  XDSNEUBemerkung.BeforeLoadDFMValues;
  XDSNEULetzterEK.BeforeLoadDFMValues;
  XDSNEUDurchschnittEK.BeforeLoadDFMValues;
  XDSNEUBenutzergeaendert.BeforeLoadDFMValues;
  XDSNEUDatumgeaendert.BeforeLoadDFMValues;
  XDSNEUArtikelEK.BeforeLoadDFMValues;
  XDSNEUBuchbestand.BeforeLoadDFMValues;
  XDSNEUBuchbestandswert.BeforeLoadDFMValues;
  XDSNEUDifferenzBestand.BeforeLoadDFMValues;
  XDSNEUNeuerBestandswert.BeforeLoadDFMValues;
  XDSNEUKorrekturDatum.BeforeLoadDFMValues;
  XDSNEUDifferenzBestandswert.BeforeLoadDFMValues;
  try
    Name := 'frmInventur';
    Width := 202;
    Height := 557;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    FormStyle := fsStayOnTop;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    labelinventuren.SetParentComponent(Self);
    labelinventuren.Name := 'labelinventuren';
    labelinventuren.Left := 8;
    labelinventuren.Top := 176;
    labelinventuren.Width := 85;
    labelinventuren.Height := 15;
    labelinventuren.Caption := 'LabelInventuren';
    labelinventuren.ElementClassName := 'h6 m-2';
    labelinventuren.ElementFont := efCSS;
    labelinventuren.ElementPosition := epIgnore;
    labelinventuren.HeightStyle := ssAuto;
    labelinventuren.HeightPercent := 100.000000000000000000;
    labelinventuren.WidthStyle := ssAuto;
    labelinventuren.WidthPercent := 100.000000000000000000;
    LabelLetzteErfassungen.SetParentComponent(Self);
    LabelLetzteErfassungen.Name := 'LabelLetzteErfassungen';
    LabelLetzteErfassungen.Left := 8;
    LabelLetzteErfassungen.Top := 195;
    LabelLetzteErfassungen.Width := 113;
    LabelLetzteErfassungen.Height := 15;
    LabelLetzteErfassungen.Caption := 'Letzte 10 Erfassungen';
    LabelLetzteErfassungen.ElementClassName := 'h6 m-2';
    LabelLetzteErfassungen.ElementFont := efCSS;
    LabelLetzteErfassungen.ElementPosition := epIgnore;
    LabelLetzteErfassungen.HeightStyle := ssAuto;
    LabelLetzteErfassungen.HeightPercent := 100.000000000000000000;
    LabelLetzteErfassungen.WidthStyle := ssAuto;
    LabelLetzteErfassungen.WidthPercent := 100.000000000000000000;
    labelsuchergebnis.SetParentComponent(Self);
    labelsuchergebnis.Name := 'labelsuchergebnis';
    labelsuchergebnis.Left := 8;
    labelsuchergebnis.Top := 207;
    labelsuchergebnis.Width := 71;
    labelsuchergebnis.Height := 15;
    labelsuchergebnis.Caption := 'Suchergebnis';
    labelsuchergebnis.ElementClassName := 'h6 m-2';
    labelsuchergebnis.ElementFont := efCSS;
    labelsuchergebnis.ElementPosition := epIgnore;
    labelsuchergebnis.HeightStyle := ssAuto;
    labelsuchergebnis.HeightPercent := 100.000000000000000000;
    labelsuchergebnis.WidthStyle := ssAuto;
    labelsuchergebnis.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 226;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    ComboLager.SetParentComponent(Self);
    ComboLager.Name := 'ComboLager';
    ComboLager.Left := 8;
    ComboLager.Top := 293;
    ComboLager.Width := 150;
    ComboLager.Height := 23;
    ComboLager.ChildOrder := 8;
    ComboLager.ElementClassName := 'form-control m-1';
    ComboLager.ElementFont := efCSS;
    ComboLager.ElementPosition := epIgnore;
    ComboLager.HeightStyle := ssAuto;
    ComboLager.HeightPercent := 100.000000000000000000;
    ComboLager.Text := 'ComboLager';
    ComboLager.WidthPercent := 75.000000000000000000;
    ComboLager.ItemIndex := -1;
    Container4.SetParentComponent(Self);
    Container4.Name := 'Container4';
    Container4.Left := 0;
    Container4.Top := 141;
    Container4.Width := 169;
    Container4.Height := 41;
    Container4.ElementClassName := 'd-flex flex-wrap m-1';
    Container4.HeightStyle := ssAuto;
    Container4.WidthStyle := ssAuto;
    Container4.ChildOrder := 5;
    Container4.ElementFont := efCSS;
    Container4.ElementPosition := epIgnore;
    btnScan.SetParentComponent(Self);
    btnScan.Name := 'btnScan';
    btnScan.Left := 8;
    btnScan.Top := 410;
    btnScan.Width := 96;
    btnScan.Height := 25;
    btnScan.Caption := 'scannen';
    btnScan.ChildOrder := 4;
    btnScan.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnScan.ElementFont := efCSS;
    btnScan.ElementPosition := epIgnore;
    btnScan.HeightStyle := ssAuto;
    btnScan.HeightPercent := 100.000000000000000000;
    btnScan.WidthStyle := ssAuto;
    btnScan.WidthPercent := 100.000000000000000000;
    SetEvent(btnScan, Self, 'OnClick', 'btnScanClick');
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 8;
    edtSuchbegriff.Top := 382;
    edtSuchbegriff.Width := 150;
    edtSuchbegriff.Height := 22;
    edtSuchbegriff.ChildOrder := 6;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.ShowHint := True;
    edtSuchbegriff.TextHint := 'Artikelnr/GTIN';
    edtSuchbegriff.WidthPercent := 60.000000000000000000;
    SetEvent(edtSuchbegriff, Self, 'OnChange', 'edtSuchbegriffChange');
    edtMenge.SetParentComponent(Self);
    edtMenge.Name := 'edtMenge';
    edtMenge.Left := 8;
    edtMenge.Top := 441;
    edtMenge.Width := 150;
    edtMenge.Height := 19;
    edtMenge.ChildOrder := 2;
    edtMenge.EditType := weFloat;
    edtMenge.ElementClassName := 'form-control input-sm m-1';
    edtMenge.ElementFont := efCSS;
    edtMenge.ElementPosition := epIgnore;
    edtMenge.HeightStyle := ssAuto;
    edtMenge.HeightPercent := 100.000000000000000000;
    edtMenge.TextHint := 'eintragen';
    edtMenge.WidthPercent := 100.000000000000000000;
    btnSpeichern.SetParentComponent(Self);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 73;
    btnSpeichern.Top := 466;
    btnSpeichern.Width := 96;
    btnSpeichern.Height := 25;
    btnSpeichern.Caption := 'speichern';
    btnSpeichern.ChildOrder := 6;
    btnSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnSpeichern.ElementFont := efCSS;
    btnSpeichern.ElementPosition := epIgnore;
    btnSpeichern.HeightStyle := ssAuto;
    btnSpeichern.HeightPercent := 100.000000000000000000;
    btnSpeichern.WidthStyle := ssAuto;
    btnSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    TCErfassung.SetParentComponent(Self);
    TCErfassung.Name := 'TCErfassung';
    TCErfassung.Left := -45;
    TCErfassung.Top := 288;
    TCErfassung.Width := 247;
    TCErfassung.Height := 91;
    TCErfassung.ElementClassName := 'table table-sm table-hover table-bordered table-striped m-1';
    TCErfassung.HeightStyle := ssAuto;
    TCErfassung.WidthStyle := ssPercent;
    TCErfassung.BorderColor := clSilver;
    TCErfassung.ChildOrder := 3;
    TCErfassung.ColHeader := False;
    TCErfassung.ElementFont := efCSS;
    TCErfassung.ElementHeaderClassName := 'table-info';
    TCErfassung.ElementPosition := epIgnore;
    TCErfassung.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TCErfassung.WordWrap := True;
    TCErfassung.ColCount := 3;
    TCLetzte10.SetParentComponent(Self);
    TCLetzte10.Name := 'TCLetzte10';
    TCLetzte10.Left := 8;
    TCLetzte10.Top := 497;
    TCLetzte10.Width := 247;
    TCLetzte10.Height := 91;
    TCLetzte10.ElementClassName := 'table table-sm table-hover table-bordered table-striped m-1';
    TCLetzte10.HeightStyle := ssAuto;
    TCLetzte10.WidthStyle := ssPercent;
    TCLetzte10.BorderColor := clSilver;
    TCLetzte10.ChildOrder := 3;
    TCLetzte10.ColHeader := False;
    TCLetzte10.ElementFont := efCSS;
    TCLetzte10.ElementHeaderClassName := 'table-info';
    TCLetzte10.ElementPosition := epIgnore;
    TCLetzte10.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TCLetzte10.WordWrap := True;
    TCLetzte10.ColCount := 3;
    xdsInventurERF.SetParentComponent(Self);
    xdsInventurERF.Name := 'xdsInventurERF';
    xdsInventurERF.AfterOpen := xdsInventurERFAfterOpen;
    xdsInventurERF.EntitySetName := 'InventurERF';
    xdsInventurERF.Connection := DM2.XDataWebConnection1;
    xdsInventurERF.SubpropsDepth := 1;
    xdsInventurERF.QueryString := '$expand=Artikelnummer,Lager&$orderby=Datumgeaendert DESC';
    xdsInventurERF.QueryTop := 10;
    xdsInventurERF.Left := 109;
    xdsInventurERF.Top := 173;
    xdsInventurERFArtikelnummer.SetParentComponent(xdsInventurERF);
    xdsInventurERFArtikelnummer.Name := 'xdsInventurERFArtikelnummer';
    xdsInventurERFArtikelnummer.FieldName := 'Artikelnummer';
    xdsInventurERFArtikelnummer.Required := True;
    xdsInventurERFLager.SetParentComponent(xdsInventurERF);
    xdsInventurERFLager.Name := 'xdsInventurERFLager';
    xdsInventurERFLager.FieldName := 'Lager';
    xdsInventurERFLager.Required := True;
    xdsInventurERFInventurdatum.SetParentComponent(xdsInventurERF);
    xdsInventurERFInventurdatum.Name := 'xdsInventurERFInventurdatum';
    xdsInventurERFInventurdatum.FieldName := 'Inventurdatum';
    xdsInventurERFInventurdatum.Required := True;
    xdsInventurERFArtikelueberschrift.SetParentComponent(xdsInventurERF);
    xdsInventurERFArtikelueberschrift.Name := 'xdsInventurERFArtikelueberschrift';
    xdsInventurERFArtikelueberschrift.FieldName := 'Artikelueberschrift';
    xdsInventurERFArtikelueberschrift.Size := 50;
    xdsInventurERFArtikelbeschreibung.SetParentComponent(xdsInventurERF);
    xdsInventurERFArtikelbeschreibung.Name := 'xdsInventurERFArtikelbeschreibung';
    xdsInventurERFArtikelbeschreibung.FieldName := 'Artikelbeschreibung';
    xdsInventurERFArtikelbeschreibung.Size := 255;
    xdsInventurERFBestand.SetParentComponent(xdsInventurERF);
    xdsInventurERFBestand.Name := 'xdsInventurERFBestand';
    xdsInventurERFBestand.FieldName := 'Bestand';
    xdsInventurERFBemerkung.SetParentComponent(xdsInventurERF);
    xdsInventurERFBemerkung.Name := 'xdsInventurERFBemerkung';
    xdsInventurERFBemerkung.FieldName := 'Bemerkung';
    xdsInventurERFBemerkung.Size := 255;
    xdsInventurERFLetzterEK.SetParentComponent(xdsInventurERF);
    xdsInventurERFLetzterEK.Name := 'xdsInventurERFLetzterEK';
    xdsInventurERFLetzterEK.FieldName := 'LetzterEK';
    xdsInventurERFDurchschnittEK.SetParentComponent(xdsInventurERF);
    xdsInventurERFDurchschnittEK.Name := 'xdsInventurERFDurchschnittEK';
    xdsInventurERFDurchschnittEK.FieldName := 'DurchschnittEK';
    xdsInventurERFBenutzergeaendert.SetParentComponent(xdsInventurERF);
    xdsInventurERFBenutzergeaendert.Name := 'xdsInventurERFBenutzergeaendert';
    xdsInventurERFBenutzergeaendert.FieldName := 'Benutzergeaendert';
    xdsInventurERFBenutzergeaendert.Size := 50;
    xdsInventurERFDatumgeaendert.SetParentComponent(xdsInventurERF);
    xdsInventurERFDatumgeaendert.Name := 'xdsInventurERFDatumgeaendert';
    xdsInventurERFDatumgeaendert.FieldName := 'Datumgeaendert';
    xdsInventurERFArtikelEK.SetParentComponent(xdsInventurERF);
    xdsInventurERFArtikelEK.Name := 'xdsInventurERFArtikelEK';
    xdsInventurERFArtikelEK.FieldName := 'ArtikelEK';
    xdsInventurERFBuchbestand.SetParentComponent(xdsInventurERF);
    xdsInventurERFBuchbestand.Name := 'xdsInventurERFBuchbestand';
    xdsInventurERFBuchbestand.FieldName := 'Buchbestand';
    xdsInventurERFBuchbestandswert.SetParentComponent(xdsInventurERF);
    xdsInventurERFBuchbestandswert.Name := 'xdsInventurERFBuchbestandswert';
    xdsInventurERFBuchbestandswert.FieldName := 'Buchbestandswert';
    xdsInventurERFDifferenzBestand.SetParentComponent(xdsInventurERF);
    xdsInventurERFDifferenzBestand.Name := 'xdsInventurERFDifferenzBestand';
    xdsInventurERFDifferenzBestand.FieldName := 'DifferenzBestand';
    xdsInventurERFNeuerBestandswert.SetParentComponent(xdsInventurERF);
    xdsInventurERFNeuerBestandswert.Name := 'xdsInventurERFNeuerBestandswert';
    xdsInventurERFNeuerBestandswert.FieldName := 'NeuerBestandswert';
    xdsInventurERFKorrekturDatum.SetParentComponent(xdsInventurERF);
    xdsInventurERFKorrekturDatum.Name := 'xdsInventurERFKorrekturDatum';
    xdsInventurERFKorrekturDatum.FieldName := 'KorrekturDatum';
    xdsInventurERFDifferenzBestandswert.SetParentComponent(xdsInventurERF);
    xdsInventurERFDifferenzBestandswert.Name := 'xdsInventurERFDifferenzBestandswert';
    xdsInventurERFDifferenzBestandswert.FieldName := 'DifferenzBestandswert';
    xdsInventurERFArtikelnummerArtikelnummer.SetParentComponent(xdsInventurERF);
    xdsInventurERFArtikelnummerArtikelnummer.Name := 'xdsInventurERFArtikelnummerArtikelnummer';
    xdsInventurERFArtikelnummerArtikelnummer.FieldName := 'Artikelnummer.Artikelnummer';
    xdsInventurERFArtikelnummerArtikelnummer.Size := 25;
    xdsInventurERFLagerLager.SetParentComponent(xdsInventurERF);
    xdsInventurERFLagerLager.Name := 'xdsInventurERFLagerLager';
    xdsInventurERFLagerLager.FieldName := 'Lager.Lager';
    xdsInventurERFLagerLager.Size := 50;
    xdsInventuren.SetParentComponent(Self);
    xdsInventuren.Name := 'xdsInventuren';
    xdsInventuren.AfterOpen := xdsInventurenAfterOpen;
    xdsInventuren.EntitySetName := 'Inventuren';
    xdsInventuren.Connection := DM2.XDataWebConnection1;
    xdsInventuren.QueryString := '$filter=Bearbeitung eq '#39'aktiv'#39'&$orderby=InventurDatum DESC';
    xdsInventuren.QueryTop := 10;
    xdsInventuren.Left := 101;
    xdsInventuren.Top := 117;
    xdsInventurenInventurDatum.SetParentComponent(xdsInventuren);
    xdsInventurenInventurDatum.Name := 'xdsInventurenInventurDatum';
    xdsInventurenInventurDatum.FieldName := 'InventurDatum';
    xdsInventurenInventurDatum.Required := True;
    xdsInventurenBearbeitung.SetParentComponent(xdsInventuren);
    xdsInventurenBearbeitung.Name := 'xdsInventurenBearbeitung';
    xdsInventurenBearbeitung.FieldName := 'Bearbeitung';
    xdsInventurenBearbeitung.Required := True;
    xdsInventurenBearbeitung.Size := 25;
    xdsLager.SetParentComponent(Self);
    xdsLager.Name := 'xdsLager';
    xdsLager.AfterOpen := xdsLagerAfterOpen;
    xdsLager.EntitySetName := 'Lager';
    xdsLager.Connection := DM2.XDataWebConnection1;
    xdsLager.QueryTop := 100;
    xdsLager.Left := 109;
    xdsLager.Top := 237;
    xdsLagerLager.SetParentComponent(xdsLager);
    xdsLagerLager.Name := 'xdsLagerLager';
    xdsLagerLager.FieldName := 'Lager';
    xdsLagerLager.Required := True;
    xdsLagerLager.Size := 50;
    DataSet.SetParentComponent(Self);
    DataSet.Name := 'DataSet';
    DataSet.AfterOpen := DataSetAfterOpen;
    DataSet.EntitySetName := 'Artikel';
    DataSet.Connection := DM2.XDataWebConnection1;
    DataSet.QueryTop := 21;
    DataSet.Left := 56;
    DataSet.Top := 72;
    DataSetArtikelnummer.SetParentComponent(DataSet);
    DataSetArtikelnummer.Name := 'DataSetArtikelnummer';
    DataSetArtikelnummer.FieldName := 'Artikelnummer';
    DataSetArtikelnummer.Required := True;
    DataSetArtikelnummer.Size := 25;
    DataSetArtikelueberschrift.SetParentComponent(DataSet);
    DataSetArtikelueberschrift.Name := 'DataSetArtikelueberschrift';
    DataSetArtikelueberschrift.FieldName := 'Artikelueberschrift';
    DataSetArtikelueberschrift.Size := 50;
    DataSetArtikelbeschreibung.SetParentComponent(DataSet);
    DataSetArtikelbeschreibung.Name := 'DataSetArtikelbeschreibung';
    DataSetArtikelbeschreibung.FieldName := 'Artikelbeschreibung';
    DataSetArtikelbeschreibung.Size := 255;
    DataSetVerkaufspreis.SetParentComponent(DataSet);
    DataSetVerkaufspreis.Name := 'DataSetVerkaufspreis';
    DataSetVerkaufspreis.FieldName := 'Verkaufspreis';
    DataSetBestand.SetParentComponent(DataSet);
    DataSetBestand.Name := 'DataSetBestand';
    DataSetBestand.FieldName := 'Bestand';
    DataSetArtikelmatchcode.SetParentComponent(DataSet);
    DataSetArtikelmatchcode.Name := 'DataSetArtikelmatchcode';
    DataSetArtikelmatchcode.FieldName := 'Artikelmatchcode';
    DataSetArtikelmatchcode.Size := 30;
    DataSetEAN.SetParentComponent(DataSet);
    DataSetEAN.Name := 'DataSetEAN';
    DataSetEAN.FieldName := 'EAN';
    DataSetEAN.Size := 15;
    DataSetEinkaufspreis.SetParentComponent(DataSet);
    DataSetEinkaufspreis.Name := 'DataSetEinkaufspreis';
    DataSetEinkaufspreis.FieldName := 'Einkaufspreis';
    XDSNEU.SetParentComponent(Self);
    XDSNEU.Name := 'XDSNEU';
    XDSNEU.AfterApplyUpdates := XDSNEUAfterApplyUpdates;
    XDSNEU.AfterOpen := XDSNEUAfterOpen;
    XDSNEU.AfterPost := XDSNEUAfterPost;
    XDSNEU.EntitySetName := 'InventurERF';
    XDSNEU.Connection := DM2.XDataWebConnection1;
    XDSNEU.QueryTop := 1;
    XDSNEU.Left := 21;
    XDSNEU.Top := 261;
    XDSNEUArtikelnummer.SetParentComponent(XDSNEU);
    XDSNEUArtikelnummer.Name := 'XDSNEUArtikelnummer';
    XDSNEUArtikelnummer.FieldName := 'Artikelnummer';
    XDSNEUArtikelnummer.Required := True;
    XDSNEULager.SetParentComponent(XDSNEU);
    XDSNEULager.Name := 'XDSNEULager';
    XDSNEULager.FieldName := 'Lager';
    XDSNEULager.Required := True;
    XDSNEUInventurdatum.SetParentComponent(XDSNEU);
    XDSNEUInventurdatum.Name := 'XDSNEUInventurdatum';
    XDSNEUInventurdatum.FieldName := 'Inventurdatum';
    XDSNEUInventurdatum.Required := True;
    XDSNEUArtikelueberschrift.SetParentComponent(XDSNEU);
    XDSNEUArtikelueberschrift.Name := 'XDSNEUArtikelueberschrift';
    XDSNEUArtikelueberschrift.FieldName := 'Artikelueberschrift';
    XDSNEUArtikelueberschrift.Size := 50;
    XDSNEUArtikelbeschreibung.SetParentComponent(XDSNEU);
    XDSNEUArtikelbeschreibung.Name := 'XDSNEUArtikelbeschreibung';
    XDSNEUArtikelbeschreibung.FieldName := 'Artikelbeschreibung';
    XDSNEUArtikelbeschreibung.Size := 255;
    XDSNEUBestand.SetParentComponent(XDSNEU);
    XDSNEUBestand.Name := 'XDSNEUBestand';
    XDSNEUBestand.FieldName := 'Bestand';
    XDSNEUBemerkung.SetParentComponent(XDSNEU);
    XDSNEUBemerkung.Name := 'XDSNEUBemerkung';
    XDSNEUBemerkung.FieldName := 'Bemerkung';
    XDSNEUBemerkung.Size := 255;
    XDSNEULetzterEK.SetParentComponent(XDSNEU);
    XDSNEULetzterEK.Name := 'XDSNEULetzterEK';
    XDSNEULetzterEK.FieldName := 'LetzterEK';
    XDSNEUDurchschnittEK.SetParentComponent(XDSNEU);
    XDSNEUDurchschnittEK.Name := 'XDSNEUDurchschnittEK';
    XDSNEUDurchschnittEK.FieldName := 'DurchschnittEK';
    XDSNEUBenutzergeaendert.SetParentComponent(XDSNEU);
    XDSNEUBenutzergeaendert.Name := 'XDSNEUBenutzergeaendert';
    XDSNEUBenutzergeaendert.FieldName := 'Benutzergeaendert';
    XDSNEUBenutzergeaendert.Size := 50;
    XDSNEUDatumgeaendert.SetParentComponent(XDSNEU);
    XDSNEUDatumgeaendert.Name := 'XDSNEUDatumgeaendert';
    XDSNEUDatumgeaendert.FieldName := 'Datumgeaendert';
    XDSNEUArtikelEK.SetParentComponent(XDSNEU);
    XDSNEUArtikelEK.Name := 'XDSNEUArtikelEK';
    XDSNEUArtikelEK.FieldName := 'ArtikelEK';
    XDSNEUBuchbestand.SetParentComponent(XDSNEU);
    XDSNEUBuchbestand.Name := 'XDSNEUBuchbestand';
    XDSNEUBuchbestand.FieldName := 'Buchbestand';
    XDSNEUBuchbestandswert.SetParentComponent(XDSNEU);
    XDSNEUBuchbestandswert.Name := 'XDSNEUBuchbestandswert';
    XDSNEUBuchbestandswert.FieldName := 'Buchbestandswert';
    XDSNEUDifferenzBestand.SetParentComponent(XDSNEU);
    XDSNEUDifferenzBestand.Name := 'XDSNEUDifferenzBestand';
    XDSNEUDifferenzBestand.FieldName := 'DifferenzBestand';
    XDSNEUNeuerBestandswert.SetParentComponent(XDSNEU);
    XDSNEUNeuerBestandswert.Name := 'XDSNEUNeuerBestandswert';
    XDSNEUNeuerBestandswert.FieldName := 'NeuerBestandswert';
    XDSNEUKorrekturDatum.SetParentComponent(XDSNEU);
    XDSNEUKorrekturDatum.Name := 'XDSNEUKorrekturDatum';
    XDSNEUKorrekturDatum.FieldName := 'KorrekturDatum';
    XDSNEUDifferenzBestandswert.SetParentComponent(XDSNEU);
    XDSNEUDifferenzBestandswert.Name := 'XDSNEUDifferenzBestandswert';
    XDSNEUDifferenzBestandswert.FieldName := 'DifferenzBestandswert';
  finally
    labelinventuren.AfterLoadDFMValues;
    LabelLetzteErfassungen.AfterLoadDFMValues;
    labelsuchergebnis.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    ComboLager.AfterLoadDFMValues;
    Container4.AfterLoadDFMValues;
    btnScan.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    edtMenge.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    TCErfassung.AfterLoadDFMValues;
    TCLetzte10.AfterLoadDFMValues;
    xdsInventurERF.AfterLoadDFMValues;
    xdsInventurERFArtikelnummer.AfterLoadDFMValues;
    xdsInventurERFLager.AfterLoadDFMValues;
    xdsInventurERFInventurdatum.AfterLoadDFMValues;
    xdsInventurERFArtikelueberschrift.AfterLoadDFMValues;
    xdsInventurERFArtikelbeschreibung.AfterLoadDFMValues;
    xdsInventurERFBestand.AfterLoadDFMValues;
    xdsInventurERFBemerkung.AfterLoadDFMValues;
    xdsInventurERFLetzterEK.AfterLoadDFMValues;
    xdsInventurERFDurchschnittEK.AfterLoadDFMValues;
    xdsInventurERFBenutzergeaendert.AfterLoadDFMValues;
    xdsInventurERFDatumgeaendert.AfterLoadDFMValues;
    xdsInventurERFArtikelEK.AfterLoadDFMValues;
    xdsInventurERFBuchbestand.AfterLoadDFMValues;
    xdsInventurERFBuchbestandswert.AfterLoadDFMValues;
    xdsInventurERFDifferenzBestand.AfterLoadDFMValues;
    xdsInventurERFNeuerBestandswert.AfterLoadDFMValues;
    xdsInventurERFKorrekturDatum.AfterLoadDFMValues;
    xdsInventurERFDifferenzBestandswert.AfterLoadDFMValues;
    xdsInventurERFArtikelnummerArtikelnummer.AfterLoadDFMValues;
    xdsInventurERFLagerLager.AfterLoadDFMValues;
    xdsInventuren.AfterLoadDFMValues;
    xdsInventurenInventurDatum.AfterLoadDFMValues;
    xdsInventurenBearbeitung.AfterLoadDFMValues;
    xdsLager.AfterLoadDFMValues;
    xdsLagerLager.AfterLoadDFMValues;
    DataSet.AfterLoadDFMValues;
    DataSetArtikelnummer.AfterLoadDFMValues;
    DataSetArtikelueberschrift.AfterLoadDFMValues;
    DataSetArtikelbeschreibung.AfterLoadDFMValues;
    DataSetVerkaufspreis.AfterLoadDFMValues;
    DataSetBestand.AfterLoadDFMValues;
    DataSetArtikelmatchcode.AfterLoadDFMValues;
    DataSetEAN.AfterLoadDFMValues;
    DataSetEinkaufspreis.AfterLoadDFMValues;
    XDSNEU.AfterLoadDFMValues;
    XDSNEUArtikelnummer.AfterLoadDFMValues;
    XDSNEULager.AfterLoadDFMValues;
    XDSNEUInventurdatum.AfterLoadDFMValues;
    XDSNEUArtikelueberschrift.AfterLoadDFMValues;
    XDSNEUArtikelbeschreibung.AfterLoadDFMValues;
    XDSNEUBestand.AfterLoadDFMValues;
    XDSNEUBemerkung.AfterLoadDFMValues;
    XDSNEULetzterEK.AfterLoadDFMValues;
    XDSNEUDurchschnittEK.AfterLoadDFMValues;
    XDSNEUBenutzergeaendert.AfterLoadDFMValues;
    XDSNEUDatumgeaendert.AfterLoadDFMValues;
    XDSNEUArtikelEK.AfterLoadDFMValues;
    XDSNEUBuchbestand.AfterLoadDFMValues;
    XDSNEUBuchbestandswert.AfterLoadDFMValues;
    XDSNEUDifferenzBestand.AfterLoadDFMValues;
    XDSNEUNeuerBestandswert.AfterLoadDFMValues;
    XDSNEUKorrekturDatum.AfterLoadDFMValues;
    XDSNEUDifferenzBestandswert.AfterLoadDFMValues;
  end;
end;

end.
